export default "__VITE_ASSET__C3MJb_DF__"